module.exports = __webpack_public_path__ + "static/img/202103151625515.e27dbcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/inspectionImg/20210315/202103151625515.jpg
// module id = KkWk
// module chunks = 11